import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, Settings, Key } from 'lucide-react';
interface PinRevealScreenProps {
  email: string;
  onContinue: () => void;
  onBack: () => void;
  onSkip?: () => void;
}
export function PinRevealScreen({
  email,
  onContinue,
  onBack,
  onSkip
}: PinRevealScreenProps) {
  const [pin, setPin] = useState('');
  useEffect(() => {
    // Generate a random 4-digit PIN
    const generatedPin = Math.floor(1000 + Math.random() * 9000).toString();
    setPin(generatedPin);
  }, []);
  return <div className="relative w-full h-screen overflow-hidden bg-slate-900" data-id="element-261">
      {/* Background */}
      <div className="absolute inset-0 z-0" data-id="element-262">
        <img src="https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=1920&q=80" alt="Interior background" className="w-full h-full object-cover opacity-20 blur-sm" data-id="element-263" />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/90 to-slate-900/70" data-id="element-264" />
      </div>

      {/* Header - Higher z-index */}
      <div className="absolute top-6 left-6 right-6 z-50 flex items-center justify-between" data-id="element-265">
        <button onClick={onBack} className="flex items-center gap-2 text-white/70 hover:text-white transition-colors" data-id="element-266">
          <ArrowLeft className="w-5 h-5" data-id="element-267" />
          <span className="text-sm" data-id="element-268">Back</span>
        </button>
        <button className="p-3 rounded-full bg-slate-800/50 backdrop-blur-sm border border-white/10 hover:bg-slate-700/50 transition-colors" data-id="element-269">
          <Settings className="w-6 h-6 text-white" data-id="element-270" />
        </button>
      </div>

      {/* Content */}
      <div className="relative z-10 flex items-center justify-center h-full" data-id="element-271">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5
      }} className="bg-slate-800/80 backdrop-blur-xl rounded-2xl p-12 border border-white/10 shadow-2xl max-w-md w-full text-center" data-id="element-272">
          <div className="flex justify-center mb-6" data-id="element-273">
            <div className="w-16 h-16 bg-cyan-500/20 rounded-full flex items-center justify-center" data-id="element-274">
              <Key className="w-8 h-8 text-cyan-400" data-id="element-275" />
            </div>
          </div>

          <h2 className="text-xl text-white/80 mb-2 uppercase tracking-wider" data-id="element-276">
            Your Home PIN
          </h2>
          <p className="text-white/50 text-sm mb-8" data-id="element-277">Assigned to {email}</p>

          <div className="bg-slate-900/50 border border-white/10 rounded-xl py-6 mb-8" data-id="element-278">
            <div className="text-5xl font-mono tracking-[0.2em] text-white font-bold ml-4" data-id="element-279">
              {pin}
            </div>
          </div>

          <p className="text-white/70 text-sm mb-8 leading-relaxed" data-id="element-280">
            Please save this PIN. You will use it to access your home designs on
            future visits.
          </p>

          <button onClick={onContinue} className="w-full px-8 py-3 bg-gradient-to-r from-cyan-600 to-cyan-500 hover:from-cyan-500 hover:to-cyan-400 text-white font-medium rounded-lg transition-all uppercase tracking-wider" data-id="element-281">
            I've Saved It, Continue
          </button>

          {onSkip && <button onClick={onSkip} className="mt-4 text-white/30 hover:text-white/60 text-sm transition-colors mx-auto block" data-id="element-282">
              Guest access →
            </button>}
        </motion.div>
      </div>
    </div>;
}